import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";

import { MultiArgSearchPipe } from "./../pipes/multiArgSearch";

@NgModule({
  declarations:[MultiArgSearchPipe],
  imports:[CommonModule],
  exports:[MultiArgSearchPipe]
})

export class MultiArgSearch{}
